import { useMutation } from '@apollo/client'
import { Button, Typography } from '@material-ui/core'
import LinkIcon from '@material-ui/icons/Link'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { USER_BULK_ACCESS_MUTATION } from '../../graphql/userManagement'
import { getTranslate } from '../../localization'
import { BulkIdCode } from '../../types/accommodation'
import { UserBrief } from '../../types/users'
import useStyles from './styles/AccessButtonSetion'

interface AccessButtonSectionProps {
  setUsers: React.Dispatch<React.SetStateAction<UserBrief[]>>
  users: UserBrief[]
  accommodationIdCodes: BulkIdCode[]
  setAccommodationIdCodes: React.Dispatch<React.SetStateAction<BulkIdCode[]>>
  setAccommodationNamesForTable: React.Dispatch<React.SetStateAction<string[]>>
  // accommodationNamesForTable: string[]
  setAutoCompleteChannelsList: React.Dispatch<any>
  setAutoCompleteTenantValue: React.Dispatch<any>
}

const AccessButtonSection: React.FC<AccessButtonSectionProps> = ({
  setUsers,
  users,
  accommodationIdCodes,
  setAccommodationIdCodes,
  setAccommodationNamesForTable,
  // accommodationNamesForTable,
  setAutoCompleteChannelsList,
  setAutoCompleteTenantValue
}) => {
  const classes = useStyles()
  const [modifiedUser, setModifiedUser] = useState<UserBrief[]>()

  useEffect(() => {
    const tempModifiedUser: UserBrief[] = users.map((user) => ({
      ID: user.ID,
      entityID: user.entityID,
      entityName: user.entityName,
      entityCode: user.entityCode,
      displayEntityCode: user.displayEntityCode,
      role: user.role,
      email: user.email,
      name: user.name,
      active: user.active,
      SelectedResourceType: {
        Label: 'Accommodation',
        LabelFA: 'اقامتگاه'
      }
    }))

    setModifiedUser(tempModifiedUser)
  }, [users])

  const [mutateFunction, { loading: loadingForAccessMutation }] = useMutation(
    USER_BULK_ACCESS_MUTATION,
    {
      onCompleted: (data) => {
        toast.success(data.userBulkAccess.message)
      }
    }
  )

  const handleClickOnReset = () => {
    setUsers([])
    setAccommodationIdCodes([])
    setAccommodationNamesForTable([])
    setAutoCompleteChannelsList(null)
    setAutoCompleteTenantValue(null)
  }

  const handleClickOnAccess = () => {
    const tempUsersIDs = modifiedUser?.map((item) => item.ID)

    mutateFunction({
      variables: {
        input: {
          userIDs: tempUsersIDs,
          selectedAccs: accommodationIdCodes
        }
      }
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.line} />
      <Button
        className={classes.accessButton}
        onClick={handleClickOnAccess}
        disabled={
          loadingForAccessMutation ||
          !(users.length > 0 || accommodationIdCodes.length > 0)
        }>
        <Typography className={classes.buttonText}>
          <LinkIcon />
          {getTranslate('Provide Access')}
        </Typography>
      </Button>
      <Button className={classes.resetButton} onClick={handleClickOnReset}>
        <Typography className={classes.buttonTextSmall}>
          <SettingsBackupRestoreIcon />
          {getTranslate('Reset')}
        </Typography>
      </Button>
      <div className={[classes.line, classes.shortLine].join(' ')} />
    </div>
  )
}

export default AccessButtonSection
